import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Topics from "@/pages/topics/page";
import Guide from "@/pages/guide/page";
import About from "@/pages/about/page";
import Submit from "@/pages/submit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "topics", element: <Topics /> },
      { path: "guide", element: <Guide /> },
      { path: "about", element: <About /> },
      { path: "submit", element: <Submit /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;